export interface MarginsPaddingConfiguration {
  trailingMargin: number;
  slightMargin: number;
  defaultMargin: number;
  mediumMargin: number;
  wideMargin: number;

  [key: string]: number;
}
